import { wordService } from "../services/wordService";

export const applyHeading4 = () =>
  wordService.applySemanticTag({ type: "section", styleBuiltIn: "Heading4", metadata: { level: 4 } });
